function getVariantSet (variantSetId) {
  if (!this.variantSets) return
  if (!variantSetId) return
  const variantSet = this.variantSets[variantSetId]
  return variantSet
}

export default getVariantSet